import { useState } from 'react'
import Tooltip from './tooltip'
import ObjectColorLegend from './object_color_legend'

export const isColorLegendSingleAccount = (legend) => {
  return !['task_priority_id', 'progress', 'wbs_color', 'user_color', 'project_color', 'company_color'].includes(legend)
}

const ObjectColorLegendSelect = ({
  value,
  onChange,
  legends = ['target_user_id', 'user_ids', 'task_priority_id', 'progress', 'task_type_id', 'task_status_id', 'wbs_color'],
  tooltip = undefined,
  draggable = false,
  isCrossAccounts = false,
  objects,
  showLegend = false
}) => {
  /* --------------------------------------------------------------------*/
  /* -------------------------    S T A T E    --------------------------*/
  /* --------------------------------------------------------------------*/

  const [isLegendVisible, setIsLegendVisible] = useState(showLegend)

  /* --------------------------------------------------------------------*/
  /* ----------------------    RENDER FUNCTION    -----------------------*/
  /* --------------------------------------------------------------------*/

  return (
    <div className={classNames('object-color-legend-select', { draggable })}>
      <div className="inner-div" style={{ float: 'left', width: 'calc(100% - 24px)' }}>
        <div className="select-wrapper">
          <select
            name="color_legend"
            id="color_legend"
            className="form-control select"
            onChange={(e) => {
              setIsLegendVisible(showLegend)
              onChange(e)
            }}
            value={value}
          >
            <option value="">{I18n.t('select-attribute')}</option>
            {legends.map((type) => (
              <option key={type} value={type} disabled={isCrossAccounts && isColorLegendSingleAccount(type)}>
                {I18n.t(`activerecord.attributes.task.${type}`, {
                  defaults: [
                    { scope: `activerecord.attributes.project.${type}` },
                    { scope: `activerecord.attributes.company.${type}` },
                    { scope: `activerecord.attributes.event.${type}` },
                    { scope: `attributes.${type}` }
                  ]
                })}
              </option>
            ))}
          </select>
        </div>
      </div>

      {tooltip && (
        <div style={{ float: 'left', width: '24px', textAlign: 'left', paddingLeft: '8px', lineHeight: '40px' }}>
          <Tooltip content={tooltip}>
            <i className="fa fa-info-circle"></i>
          </Tooltip>
        </div>
      )}

      <div className="clearfix"></div>

      {showLegend && !isLegendVisible && (
        <a
          href="#"
          className="legend-visibility-link"
          onClick={(e) => {
            e.preventDefault()
            setIsLegendVisible(true)
          }}
        >
          {I18n.t('view')}
        </a>
      )}

      <div
        className={classNames('legend-options', {
          hidden: !value || !isLegendVisible
        })}
      >
        <a
          href="#"
          className="mb-8 display-block"
          onClick={(e) => {
            e.preventDefault()
            setIsLegendVisible(false)
          }}
        >
          {I18n.t('hide')}
        </a>

        <ObjectColorLegend legend={value} draggable={draggable} objects={objects} />
      </div>
    </div>
  )
}

export default ObjectColorLegendSelect
